






































import {Component, Prop, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import TableToExcel from "@linways/table-to-excel";
import PLCostPrint from "@/modules/pickinglistcost/components/PickingListCostPrint/index.vue";
import PLCostExcel from "@/modules/pickinglistcost/components/PickingListCostExcel/index.vue";
import {PickingListCostStore} from "@/modules/pickinglistcost";

@Component({
    name: "PLCostDetail",
    components: {PLCostExcel, PLCostPrint}
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible", {type: Boolean, default: false}) syncedVisible!: boolean;
    @Prop({type: Number, required: true}) readonly id!: number;

    printPickingListObj: Options = {
        id: 'print-picking-list-cost',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    get pickingListCost() {
        return PickingListCostStore.data[this.id];
    }

    closeModal() {
        this.syncedVisible = false;
    }

    printPickingList() {
        this.$print(this.printPickingListObj);
    }

    exportExcel() {
        TableToExcel.convert(document.getElementById("table-excel-pl-cost"), {
            name: `Bảng kê chi trả chi phí.xlsx`,
            sheet: {
                name: "Sheet 1"
            }
        });
    }
}
